import { redo, undo } from '~/store/temporalActions';
import { useShortcut } from './useShortcut';

export function useGlobalShortcuts() {
  useShortcut('undo', undo);
  useShortcut('redo', redo);
  useShortcut('exportAtlas', () => {
    window.dispatchEvent(new CustomEvent('spriteer:export'));
  });
}
